import { useTranslation } from 'react-i18next'
import React from 'react'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'

import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import UsersOrGroupsSelect from '../../../../../../containers/users/select/UsersOrGroupsSelect.js'

const UpdateServiceOrderUserOrGroup = () => {
  const { t } = useTranslation(['triggers', 'common'])
  const [open, setOpen] = React.useState()
  const { handleChangeIn, form } = useFormState()

  const dataToChange = () => {
    if (form.payload.content) {
      if (form.payload?.content?.__typename === 'User') {
        return t('updateServiceOrderUserOrGroup.user', { name: form.payload.content.name })
      } else {
        if (Array.isArray(form.payload.content)) return t('updateServiceOrderUserOrGroup.groups')

        return t('updateServiceOrderUserOrGroup.group', { name: form.payload.content.name })
      }
    }
    return '_______'
  }

  return (
    <>
      <Text size="h2">
        {Array.isArray(form?.payload?.content)
          ? t('updateServiceOrderUserOrGroup.withThe')
          : t('updateServiceOrderUserOrGroup.withThe')}
      </Text>
      <EditableSentence label={dataToChange()} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Title size="h5" bold>
          {t('actions.update_service_order_user_or_group')}
        </Title>
        <Separator weight={4} />

        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label={t('triggers:fields.responsible')}
              path={['payload', 'content']}
              Input={UsersOrGroupsSelect}
              singleLine
              // afterChange={value => {
              //   handleChangeIn(['payload', 'content'], value)
              //   console.log(value)
              // }}
            />
          </Col>
        </Grid>
        <SubmitBar label={t('common:save')} onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default UpdateServiceOrderUserOrGroup
